import React, { Component } from 'react';

import { MDBRow } from 'mdbreact';
import ImageGallery from 'react-image-gallery';

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

class Real10 extends Component {

  render() {
    
    const images = [
      {
        original: require("../../assets/images/hayon/hayon1.jpg"),
        thumbnail: require("../../assets/images/hayon/hayon1.jpg")
      },
      {
        original: require("../../assets/images/hayon/hayon2.jpg"),
        thumbnail: require("../../assets/images/hayon/hayon2.jpg")
      },
      {
        original: require("../../assets/images/hayon/hayon3.jpg"),
        thumbnail: require("../../assets/images/hayon/hayon3.jpg")
      },
      {
        original: require("../../assets/images/hayon/hayon4.jpg"),
        thumbnail: require("../../assets/images/hayon/hayon4.jpg")
      },
      {
        original: require("../../assets/images/hayon/hayon5.jpg"),
        thumbnail: require("../../assets/images/hayon/hayon5.jpg")
      }
    ];

    return (
      <MDBRow className="Real">
        <h1>Pose d'un hayon</h1>
        <ImageGallery
          items={images}
          showIndex={true}
          showPlayButton={false}
          showThumbnails={false}
          showFullscreenButton={false}
        />
      </MDBRow>
    )
  }
}

export default Real10;